






import Quill, { Delta } from 'quill';
import { setInterval } from 'timers';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

const toolbarConfig = [
  [{ header: [1, 2, 3, 4, false] }], // custom dropdown
  ['bold', 'italic', 'underline'], // toggled buttons
  ['blockquote', 'code-block'], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ align: [] }], // font align
  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }], // select font
  ['clean'], // clear formatting
  ['undo', 'redo'], // undo and redo buttons
];

const historyConfig = {
  delay: 1000, // interval that is considered a single change
  maxStack: 500, // max size of the undo/redo stack
};

@Component({})
export default class RichText extends Vue {
  @Prop({ default: 'Enter some rich text...' })
  public placeholder!: string;

  @Prop() public localSaveId?: string;
  @Prop({ default: 5 })
  public localSaveInterval!: number;

  @Prop({ default: 30 })
  public remoteStorageInterval!: number;

  @Prop({ default: null })
  public savedDraft!: null | Delta;

  @Prop({ default: '' })
  public savedHtml!: string;

  public text: string = '';
  public quill!: Quill;

  public mounted() {
    this.initializeQuill();
    this.initializeHandlers();
    this.loadSavedData();

    this.initializeIntervals();
  }

  private loadFromLocal() {
    const key = this.getLocalKey();
    if (!key) {
      return false;
    }

    const data = localStorage.getItem(key);
    if (!data || !data.length) {
      return false;
    }

    this.quill.setContents(JSON.parse(data));
    return true;
  }

  private loadSavedData() {
    if (this.loadFromLocal()) {
      console.log('loaded from local storage');
      return;
    }

    if (this.savedDraft) {
      this.quill.setContents(this.savedDraft);
    } else if (this.savedHtml && this.savedHtml.length) {
      console.log('loaded html');
      this.quill.root.innerHTML = this.savedHtml;
    }
  }

  private saveDeltaLocal(delta: Delta) {
    const key = this.getLocalKey();
    if (!key) {
      return;
    }

    localStorage.setItem(key, JSON.stringify(delta));
  }

  private getLocalKey() {
    return this.localSaveId ? `text_${this.localSaveId}` : null;
  }

  private initializeIntervals() {
    if (this.localSaveId) {
      setInterval(
        () => this.saveDeltaLocal(this.quill.getContents()),
        this.localSaveInterval * 1000
      );
    }

    setInterval(
      () => this.$emit('saveDraft', this.text, this.quill.getContents()),
      this.remoteStorageInterval * 1000
    );
  }

  private initializeHandlers() {
    this.quill.on('text-change', delta => {
      let editorContent = this.quill.root.innerHTML;
      if (editorContent === '<p><br></p>') {
        editorContent = '';
      }

      this.text = editorContent;
      this.$emit('input', editorContent);
    });
  }

  private initializeQuill() {
    this.quill = new Quill('#editor', {
      modules: {
        toolbar: {
          container: toolbarConfig,
          handlers: {
            undo: () => (this.quill as any).history.undo(),
            redo: () => (this.quill as any).history.redo(),
          },
        },
        history: historyConfig,
      },
      placeholder: this.placeholder,
      theme: 'snow',
    });

    // Add the icons for undo and redo
    const undo = document.getElementsByClassName('ql-undo')[0];
    const redo = document.getElementsByClassName('ql-redo')[0];
    undo.innerHTML = '<i class="fas fa-undo"/>';
    redo.innerHTML = '<i class="fas fa-redo"/>';
  }
}
